(function(angular, module) {var baseState, stateConfig, viewState;

baseState = {
  abstract: true,
  url: "/{id:int}",
  templateUrl: 'empty',
  resolve: {
    changeLogItem: function($stateParams, ChangeLogService) {
      'ngInject';
      return ChangeLogService.get($stateParams.id);
    }
  }
};

viewState = {
  url: '',
  template: '<change-log-item item="ctrl.changeLogItem"></change-log-item>',
  controllerAs: 'ctrl',
  controller: function(changeLogItem) {
    'ngInject';
    this.changeLogItem = changeLogItem;
  }
};

stateConfig = function($stateProvider) {
  'ngInject';
  $stateProvider.state('changeLog.item', baseState);
  $stateProvider.state('changeLog.item.view', viewState);
};

module.config(stateConfig);
})(angular, angular.module("changeLog"));